import { NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { ModalStack } from "../../internals/modal-stack";

export interface WafModalRef<T> {
  componentInstance: any;
  result: Promise<T>;
  close(result?: any): void;
  dismiss(reason?: any): void;
}

export class WafModalRefImpl<T> implements WafModalRef<T> {
  get componentInstance() {
    return this.ngbModalRef.componentInstance;
  }

  get result() {
    return this.resultPromise;
  }

  constructor(
    private ngbModalRef: NgbModalRef,
    private resultPromise: Promise<T>
  ) {}

  close(result?: any) {
    ModalStack.closeModal(this.ngbModalRef, result);
  }

  dismiss(reason?: any) {
    ModalStack.dismissModal(this.ngbModalRef, reason);
  }
}
